<template>
  <div class="mf_xtra mt-4">100% gratuit</div>
</template>
<script>
export default {};
</script>
<style lang="scss">
@import "../../../../../../resources/sass/_variables.scss";

.mf_xtra {
  color: $purple_color;
  display: flex;
  justify-content: flex-end;
}
</style>